import sha256 from 'crypto-js/sha256';
import enc from 'crypto-js/enc-hex';

const userIdHandlers = {
  encryptUsername: (payload) => {
    return sha256(payload).toString(enc.Hex);
  },
  saveUserId: (payload) => {
    localStorage.setItem('userId', payload);
  },
  retrieveUserId: () => {
    return localStorage.getItem('userId');
  },
};

export const { encryptUsername, retrieveUserId, saveUserId } = userIdHandlers;
